// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as ReactFinalForm from "react-final-form";
import * as Utils$OrcaPaymentPage from "../../Utilities/Utils.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../../Utilities/JotaiAtoms.bs.js";
import * as DropdownField$OrcaPaymentPage from "../DropdownField.bs.js";
import * as DynamicFieldsUtils$OrcaPaymentPage from "../../Utilities/DynamicFieldsUtils.bs.js";

function CountryDropdownField(props) {
  var options = props.options;
  var fieldConfig = props.fieldConfig;
  var match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var match$1 = DynamicFieldsUtils$OrcaPaymentPage.resolveFieldTexts(fieldConfig, localeString);
  var validate = DynamicFieldsUtils$OrcaPaymentPage.resolveValidator(fieldConfig, localeString);
  var match$2 = Jotai.useAtom(JotaiAtoms$OrcaPaymentPage.userCountry);
  var setCountryName = match$2[1];
  var countryName = match$2[0];
  var firstCountryName = Core__Option.getOr(Core__Option.map(options[0], (function (opt) {
              return opt.value;
            })), "");
  var defaultCountryName = countryName !== "" ? countryName : firstCountryName;
  var defaultIso = Utils$OrcaPaymentPage.getCountryCode(defaultCountryName).isoAlpha2;
  var defaultIsoRef = React.useRef(defaultIso);
  var field = ReactFinalForm.useField(fieldConfig.confirmRequestWritePath, {
        defaultValue: Caml_option.some(defaultIsoRef.current),
        validate: validate
      });
  var storedIso = Core__Option.getOr(field.input.value, "");
  var effectiveCountryName = storedIso !== "" ? Utils$OrcaPaymentPage.getCountryNameFromCode(storedIso) : defaultCountryName;
  React.useEffect((function () {
          if (effectiveCountryName !== "" && countryName !== effectiveCountryName) {
            setCountryName(function (param) {
                  return effectiveCountryName;
                });
          }
          
        }), [
        effectiveCountryName,
        countryName
      ]);
  return React.createElement(DropdownField$OrcaPaymentPage.make, {
              appearance: match.config.appearance,
              value: effectiveCountryName,
              setValue: (function (setter) {
                  var selectedCountryName = setter(effectiveCountryName);
                  setCountryName(function (param) {
                        return selectedCountryName;
                      });
                  var selectedIso = Utils$OrcaPaymentPage.getCountryCode(selectedCountryName).isoAlpha2;
                  field.input.onChange(selectedIso);
                }),
              fieldName: match$1.label,
              options: options,
              disabled: false
            });
}

var make = CountryDropdownField;

export {
  make ,
}
/* jotai Not a pure module */
